import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import Button from '@material-ui/core/Button';
import GridItem from '../components/GridItem';
import AppBar from '@material-ui/core/AppBar';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import Divider from '@material-ui/core/Divider';
import CheckCircle from '@material-ui/icons/CheckCircle';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import { Link } from 'react-router-dom'
import dbProject from '../db.json';

class GridContainer extends Component {
  state = {
    projects: null,
  }

  constructor() {
    super();
    this.container = React.createRef();

    // we need to store several tops for each column keyed by column index
    this.lastTop = {};
    this.lastLeft = 0;
  }

  async componentDidMount() {
    const id = this.props.match.params.id;
    // const results = await fetch(`http://localhost:3001/my-projects`)
    // const projects = await results.json();

    const projects = dbProject['my-projects']
    this.setState({
      projects,
    })
  }

  render() {
    const {
      images,
      imageAspectRatios,
      imageStyles
    } = this.state;

    const { projects, selectedLayer, layersSmall } = this.state;
    const isLoaded = true;
    console.log('projects!!!', projects)
    return (
      <Fragment>
      <AppBar className="navigation">
         <Typography inline variant="h5" className="header-text">
            Projects
          </Typography>
      </AppBar>
      <div className="project-container">
        {
          projects && projects.map(project => (
            <Link to={`/projects/${project.id}`}>
              <div className="project-item">
                <img src={project.image.url} className="project-item-image" />
              </div>
            </Link>
          ))
        }

      </div>
      </Fragment>
    )
  }
}

export default GridContainer;


// WEBPACK FOOTER //
// ./src/containers/Projects.js